module.exports = __webpack_public_path__ + "557276990e31531c526e4a553ce54301.fbx";